/** Matches the trailing pb-2 in both calendar hosts. */
export const CALENDAR_FRAME_BOTTOM_GAP = 8;
